/**
 * Created by claudio iozzia on 10/03/2017.
 */
import {
  Routes,
  RouterModule,
  CanActivate,
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";
import { MainContentComponent } from "./components/main-content/main-content.component";
import { Injectable } from "@angular/core";
import { NavCatalogComponent } from "./components/nav-catalog/nav-catalog.component";
import { SelectedDesignComponent } from "./components/selected-design/selected-design.component";
import { IcListComponent } from "./components/ic-list/ic-list.component";
import { IcGridComponent } from "./components/ic-grid/ic-grid.component";
import { RedirectToEdsComponent } from "./components/redirect-to-eds/redirect-to-eds.component";
import { ParseFromWidgetComponent } from "./components/parse-from-widget/parse-from-widget.component";
import { ErrorComponent } from "./components/error/error.component";
import { HelpPageComponent } from "./components/help-page/help-page.component";
import {SupportComponent} from "./components/support/support.component";
import {HomePageComponent} from "./components/home-page/home-page.component";
import {HackathonPageComponent} from "./components/hackathon-page/hackathon-page.component";

@Injectable()
export class AuthGuard
  implements CanActivate, CanDeactivate<MainContentComponent> {
  canDeactivate(
    component: MainContentComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return confirm("De Activate?");
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return confirm("Activate?");
  }
}

const routes: Routes = [
  // {
  //   path: 'ask',
  //   component:  MainContentComponent,
  //   canActivate: [AuthGuard],
  //   canDeactivate: [AuthGuard]
  // },

  {
    path: "",
    redirectTo: "/home",
    pathMatch: "full"
  },
  {
    path: "help",
    component: HelpPageComponent
  },
  {
    path: "hackathon",
    component: HackathonPageComponent
  },
  {
    path: "error",
    children: [{ path: "", pathMatch: "full", component: ErrorComponent }]
  },
  {
    path: "eds/:link",
    pathMatch: "prefix",
    children: [
      {
        component: RedirectToEdsComponent,
        path: "**"
      }
    ]
  },
  {
    path: "widget/:param",
    pathMatch: "prefix",
    children: [
      {
        component: ParseFromWidgetComponent,
        path: "**"
      }
    ]
  },
  {
    path: "home",
    children: [{ path: "", pathMatch: "full", component: HomePageComponent }]
  },
  {
    path: "dashboard",
    children: [{ path: "", pathMatch: "full", component: NavCatalogComponent, data : {showDashboard : true} }]
  },
  {
    path: "app/:class/:catalog/filter/:filter",
    component: MainContentComponent,
    children: [
      { path: "", pathMatch: "prefix", redirectTo: "grid" },
      { path: "grid", component: IcGridComponent },
      { path: "list", component: IcListComponent },
      { path: "selected/:ic", component: SelectedDesignComponent }
    ]
  },
  {
    path: "support/:lang/:request",
    pathMatch: "prefix",
    children: [
      {
        component: SupportComponent,
        path: "**"
      }
    ]
  },
  {
    path: "**",
    redirectTo: "error"
  }
];

export const eSelectorRouterModule = RouterModule.forRoot(routes);
